export const NOTIFICATION_APPROVAL_MODULE = {
  ACTION_TYPES: {
    onDisplay: 'onDisplay',
    onDialogClick: 'onDialogClick'
  },

  LOGO_SIZES: {
      desktop: 20,
      mobile: 15
  },

  FIRST_TIME_DISPLAY: 1
};